import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: index,
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('../views/home/index.vue'),
        meta: { title: '首页' }
      },
      {
        path: '/AI',
        name: 'AI',
        component: () => import('../views/AI/index.vue'),
        meta: { title: 'AI' }
      },
      {
        path: '/WorkBuddy/:targetId?',
        name: 'WorkBuddy',
        component: () => import('../views/WorkBuddy/index.vue'),
        meta: { title: 'WorkBuddy' }
      },
      {
        path: '/AIMenu/:id?',
        name: 'AIMenu',
        component: () => import('../views/AI/indexc.vue'),
        meta: { title: 'AIMenu' }
      },
      {
        path: '/fdeService',
        name: 'fdeService',
        component: () => import('../views/fde/index.vue'),
        meta: { title: 'FDE落地服务' }
      },
      {
        path: '/AIAgentMain',
        name: 'AIAgentMain',
        component: () => import('../views/AI/agent.vue'),
        meta: { title: 'AI智能体' }
      },
      {
        path: '/Aiagentaipas',
        name: 'Aiagentaipas',
        component: () => import('../views/AI/AIagentaipas.vue'),
        meta: { title: 'AI智能体中台' }
      },
      {
        path: '/AIAgentADP',
        name: 'AIAgentADP',
        component: () => import('../views/AI/adp.vue'),
        meta: { title: '腾讯云智能体开发平台 ADP' }
      },
      {
        path: '/AIAgentTokenHub',
        name: 'AIAgentTokenHub',
        component: () => import('../views/AI/tokenhub.vue'),
        meta: { title: '大模型服务平台 TokenHub' }
      },
      
      {
        path: '/AIAgentCodeBuddy',
        name: 'AIAgentCodeBuddy',
        component: () => import('../views/AI/codebuddy.vue'),
        meta: { title: 'CodeBuddy' }
      },
      {
        path: '/product/:id?',
        name: 'product',
        component: () => import('../views/product/index.vue'),
        meta: { title: '产品' }
      },
      {
        path: '/app/:id?',
        name: 'app',
        component: () => import('../views/app/index.vue'),
        meta: { title: '应用' }
      },
      {
        path: '/solution/:index?',
        name: 'solution',
        component: () => import('../views/solution/indexNew.vue'),
        meta: { title: '解决方案' }
      },
      {
        path: '/wbIndustry/:index?',
        name: 'wbIndustry',
        component: () => import('../views/wbIndustry/index.vue'),
        meta: { title: '行业应用案例' }
      },
      {
        path: '/crmcase/:id?/:title?',
        name: 'crmcase',
        component: () => import('../views/crmcase/index.vue'),
        meta: { title: '客户案例' }
      },
      {
        path: '/crmcaseinfo/:id?/:index?',
        name: 'crmcaseinfo',
        component: () => import('../views/crmcaseinfo/index.vue'),
        meta: { title: '案例详情' }
      },
      {
        path: '/aboutus',
        name: 'aboutus',
        component: () => import('../views/aboutus/index.vue'),
        meta: { title: '关于我们' }
      },
      {
        path: '/contactForm',
        name: 'contactForm',
        component: () => import('../views/contactForm/index.vue'),
        meta: { title: '联系表单' }
      },
      {
        // 兜底路由：必须放在最后。命中后由页面给出站内入口，nginx 侧对静态栏目返回真实 404
        path: '*',
        name: 'notFound',
        component: () => import('../views/notFound/index.vue'),
        meta: { title: '页面不存在' }
      }
    ]
  }
  // {
  //   path: '/mwzb',
  //   name: 'Mwzb',
  //   component: () => import('../views/form/mwzb.vue'),
  //   meta: { title: '门卫值班' }
  // }
]

const router = new VueRouter({
  // mode: 'hash',
  mode:'history',
  routes
})

export default router
